import * as React from 'react';
import { useRoutes } from 'react-router-dom';

import { Login } from 'features/auth/routes/Login';
import useNotifier from 'hooks/useNotifier';
import { useAuth } from 'lib/auth';

import protectedRoutes, { DashboardOrRedirect } from './protected';
import { publicRoutes } from './public';

const AppRoutes = () => {
  const { user } = useAuth();
  useNotifier();

  const commonRoutes = [
    {
      path: '/',
      // ログイン直後はこのルートが先に描画される。外部管理者（一城等）は
      // ダッシュボードを描画せず自スコープのホームへ飛ばす（レポートAPIの403を発生させない）
      element: user ? <DashboardOrRedirect /> : <Login />,
    },
  ];

  const routes = user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <div>{element}</div>;
};

export default AppRoutes;
